import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { Text, IconArrowLeft } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';

export const MoreButton = memo(
  ({ style, textStyle, arrowColor, onPress, disabled, title }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();

    return (
      <TouchableOpacity
        disabled={disabled}
        style={[styles.container, style]}
        activeOpacity={0.7}
        onPress={onPress}
      >
        <Text style={[styles.text, textStyle]}>{title || dictionary.total}</Text>
        <IconArrowLeft color={arrowColor || colors.primary} />
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  text: {
    fontSize: 14,
    color: colors.primary,
  },
}));
